import {
  GET_USER_ID,
  GET_PAYMENT_HISTORY,
  GET_SCHEDULED_PAYMENT,
  GET_TRANSACTIONS_HISTORY,
  GET_CONTRACTS,
  GET_NOTIFICATIONS,
  GET_ACTIVE_TAB,
  GET_CUSTOMER_INFORMATION,
  GET_CUSTOMER_DETAILS,
  GET_INPROGRESS_PAYMENTS,
  GET_OTP,
  GET_USER_DETAIL,
  GET_ASSET_INFORMATION,
  GET_MACHINE_HEALTH_DETAILS,
  GET_SKIP_TOUR,
  GET_USER_NAME,
  RESET_PRESERVED_STATE,
  UPDATE_CUSTOMER_DETAILS,
  GET_USER_LOCALE,
  UPDATE_TNC_ACCEPTED,
  UPDATE_DD_TNC_ACCEPTED,
  SET_OFFERS_LOADING,
  SET_OFFERS_FOR_MFA_CUSTOMER,
  SET_PERSONAL_OFFERS_LETTER_LOADING,
  SET_PERSONAL_OFFERS_LETTER_DATA,
  SET_SHOW_HIDE_PERSONAL_OFFER_LETTER,
  UPDATE_USER_SCRATCH_THE_CARD,
  SET_NON_MFA_USER_MOBILE_NUMBER,
  SET_NON_MFA_USER_DATA,
  SET_NON_MFA_ALERT,
  RESET_NON_MFA_ALERT,
  NON_MFA_USER_VERIFICATION_SUCCESS,
  SET_OFFERS_FOR_MFA_NON_CUSTOMER,
  SET_OFFER_FOUND_BY_ID,
  SET_NON_MFA_OFFERS_LOADING,
  SET_SELECTED_OFFER_NON_MFA_CUSTOMER,
  SET_CUSTOM_ALERT,
  SET_OFFERS_VIEW,
  SET_PREVIOUS_SUBMITTED_OFFERS_NON_MFA,
  REMOVE_USER_DETAILS,
  NON_MFA_SET_VIEW,
  ASK_USER_TO_ENABLE_PUSH,
  SET_OFFERS_SUBMIT,
  UPDATE_WHATSAPP_OPT_IN_DETAILS,
  SET_CONFIRM_PAYMENT_DATA,
  SET_TOTAL_ON_ACCOUNT_PAYMENT,
  SET_TOTAL_ON_ACCOUNT_WITH_CONTRACT_NUMBER,
  PAYMENT_HISTORY_UNAVAILABLE,
} from '../actions';

const initialState = {
  userId: null,
  paymentHistoryData: null,
  scheduledPaymentData: null,
  transactionsHistoryData: null,
  contractData: null,
  inAppNotificationData: null,
  activeTab: 'home',
  customerInformation: null,
  inprogressPayments: null,
  confirmPaymentData: null,
  loginOTP: '',
  userDetail: null,
  assetInformationData: null,
  allMachineHealthDetails: {
    isMachineHealthDetailsAvailable: false,
    machineHealthDetails: null,
  },
  skipTour: null,
  customerDetailsData: null,
  userName: null,
  userLocale: null,
  offersForMFACustomers: {
    offersLoading: false,
    currentView: 'offers',
    enquirySubmitStatus: 'NA',
  },
  offersForNonMFACustomers: {
    offersLoading: false,
    noOfferFoundById: false,
    viewName: '',
    previouslySubmittedOffers: [],
  },
  personalOfferLetterLoading: false,
  personalOfferLetterData: {},
  nonMfaUserData: {isUserVerified: false},
  nonMfaAlert: {showAlert: false},
  customAlert: {showAlert: false},
  askForNotification: false,
  onAccountPaymentWithContractNumber: [],
  paymentHistoryUnavailableContracts: [],
};

const setUserId = (state, {userId}) => {
  return {
    ...state,
    userId,
  };
};

const setPaymentHistoryData = (state, {paymentHistoryData}) => {
  return {
    ...state,
    paymentHistoryData,
  };
};

const setScheduledPaymentData = (state, {scheduledPaymentData}) => {
  return {
    ...state,
    scheduledPaymentData: {...scheduledPaymentData},
  };
};

const setTransactionsHistoryData = (state, {transactionsHistoryData}) => {
  return {
    ...state,
    transactionsHistoryData,
  };
};

const setContractData = (state, {contractData}) => {
  return {
    ...state,
    contractData,
  };
};

const setInAppNotificationData = (state, {inAppNotificationData}) => {
  return {
    ...state,
    inAppNotificationData,
  };
};

const setActiveTab = (state, {activeTab}) => {
  return {
    ...state,
    activeTab,
  };
};

const setCustomerInformation = (state, {customerInformation}) => {
  return {
    ...state,
    customerInformation,
  };
};

const setInprogressPayments = (state, {inprogressPayments}) => {
  return {
    ...state,
    inprogressPayments,
  };
};

const setOtp = (state, {loginOTP}) => {
  return {
    ...state,
    loginOTP,
  };
};

const removeUserDetails = (state) => {
  return {
    ...state,
    userDetail: null,
  };
};
const setUserDetails = (state, {userDetail}) => {
  return {
    ...state,
    ...userDetail,
    userDetail: {...userDetail},
  };
};

const setAssetInformationData = (state, {assetInformationData}) => {
  return {
    ...state,
    assetInformationData,
  };
};

const setMachineHealthDetails = (state, {machineHealthDetails}) => {
  const isMachineHealthDetailsAvailable =
    Array.isArray(machineHealthDetails) && machineHealthDetails.length > 0;

  return {
    ...state,
    allMachineHealthDetails: {
      machineHealthDetails,
      isMachineHealthDetailsAvailable,
    },
  };
};

const setSkipTour = (state, {skipTour}) => {
  return {
    ...state,
    skipTour,
  };
};

const setCustomerDetails = (state, {customerDetailsData}) => {
  return {
    ...state,
    customerDetailsData,
  };
};

const setUserName = (state, {userName}) => {
  return {
    ...state,
    userName,
  };
};
const updateCustomerDetails = (state) => {
  return {
    ...state,
    customerDetailsData: {
      ...state.customerDetailsData,
      isFarmSetupCompleted: 'Y',
    },
  };
};

const updateCustomerDetailsWhatsappOptIn = (state, {data}) => {
  return {
    ...state,
    customerDetailsData: {
      ...state.customerDetailsData,
      ...data,
    },
  };
};

const resetPreserveState = (state) => {
  return {
    ...state,
    userId: null,
    contractData: null,
    customerDetailsData: null,
  };
};

const setUserLocale = (state, {userLocale}) => {
  return {
    ...state,
    userLocale,
  };
};

const updateTnCAcceptedDetails = (state) => {
  return {
    ...state,
    customerDetailsData: {
      ...state.customerDetailsData,
      tncAccepted: 'Y',
    },
  };
};

const updateDDTnCAcceptedDetails = (state) => {
  return {
    ...state,
    customerDetailsData: {
      ...state.customerDetailsData,
      ddtncAccepted: 'Y',
    },
  };
};

const setOffersLoading = (state, {offersLoading}) => {
  return {
    ...state,
    offersForMFACustomers: {
      ...state.offersForMFACustomers,
      offersLoading: offersLoading,
    },
  };
};

const setOfferView = (state, {viewName}) => {
  return {
    ...state,
    offersForMFACustomers: {
      ...state.offersForMFACustomers,
      currentView: viewName,
    },
  };
};
const setOfferSubmit = (state, {data}) => {
  return {
    ...state,
    offersForMFACustomers: {
      ...state.offersForMFACustomers,
      enquirySubmitStatus: data,
    },
  };
};

const setPersonalOffersLetterLoading = (
  state,
  {personalOfferLetterLoading}
) => {
  return {
    ...state,
    personalOfferLetterLoading: personalOfferLetterLoading,
  };
};

const setPersonalOffersLetterData = (state, {personalOfferLetterData}) => {
  return {
    ...state,
    personalOfferLetterData: personalOfferLetterData,
  };
};

const setOffersData = (state, {allOffersAvailableForMFACustomer}) => {
  return {
    ...state,
    offersForMFACustomers: {
      ...state.offersForMFACustomers,
      offers: allOffersAvailableForMFACustomer,
    },
  };
};

const setOffersNonMfaData = (state, {allOffersAvailableForNonMFACustomer}) => {
  return {
    ...state,
    offersForNonMFACustomers: {
      ...state.offersForNonMFACustomers,
      offers: allOffersAvailableForNonMFACustomer,
    },
  };
};

const setSelectedOfferNonMfaData = (state, {selectedOffer}) => {
  return {
    ...state,
    offersForNonMFACustomers: {
      ...state.offersForNonMFACustomers,
      selectedOffer: selectedOffer,
    },
  };
};

const setShowHidePersonalLetter = (state, data) => {
  return {
    ...state,
    personalOfferLetterData: {
      ...state.personalOfferLetterData,
      showCard: data.showPersonalOfferCard,
    },
  };
};

const updateUserScratchTheCard = (state, data) => {
  return {
    ...state,
    personalOfferLetterData: {
      ...state.personalOfferLetterData,
      userScratchTheCard: data.userScratchTheCard,
    },
  };
};

const setNonMFAUserPhoneNumber = (state, {phoneNumber}) => {
  return {
    ...state,
    nonMfaUserData: {
      ...state.nonMfaUserData,
      phoneNumber,
    },
  };
};

const updateOfferFoundById = (state, {NoOfferFound}) => {
  return {
    ...state,
    offersForNonMFACustomers: {
      ...state.offersForNonMFACustomers,
      noOfferFoundById: NoOfferFound,
    },
  };
};

const updateNonMFAUserData = (state, {data}) => {
  return {
    ...state,
    nonMfaUserData: {
      ...state.nonMfaUserData,
      ...data,
    },
  };
};

const setNonMfaAlert = (state, {message}) => {
  return {
    ...state,
    nonMfaAlert: {
      showAlert: message.showAlert,
      type: message.type,
      alertVariant: message.alertVariant,
    },
  };
};

const showHideAlert = (state, {message}) => {
  return {
    ...state,
    customAlert: {
      showAlert: message.showAlert,
      type: message.type,
      alertVariant: message.alertVariant,
    },
  };
};

const resetNonMfaAlert = (state, data) => {
  return {
    ...state,
    nonMfaAlert: {
      showAlert: false,
    },
  };
};

const nonMfaUserVerificationSuccess = (state, data) => {
  return {
    ...state,
    nonMfaUserData: {
      ...state.nonMfaUserData,
      isUserVerified: true,
    },
  };
};

const setNonMFAUsersOffersLoading = (state, {offersLoading}) => {
  return {
    ...state,
    offersForNonMFACustomers: {
      ...state.offersForNonMFACustomers,
      offersLoading: offersLoading,
    },
  };
};

const setViewNonMFA = (state, {viewName}) => {
  return {
    ...state,
    offersForNonMFACustomers: {
      ...state.offersForNonMFACustomers,
      viewName: viewName,
    },
  };
};

const setPreviouslySubmittedOffers = (state, {data}) => {
  return {
    ...state,
    offersForNonMFACustomers: {
      ...state.offersForNonMFACustomers,
      previouslySubmittedOffers: data,
    },
  };
};

const askUserToEnablePush = (state, {data}) => {
  return {
    ...state,
    askForNotification: data,
  };
};

const setOnAccountPayment = (state, {totalOnAccountPaymentMade}) => {
  return {
    ...state,
    totalOnAccountPayment: totalOnAccountPaymentMade,
  };
};

const setOnAccountPaymentWithContractNumber = (
  state,
  {onAccountPaymentWithContractNumber}
) => {
  return {
    ...state,
    onAccountPaymentWithContractNumber,
  };
};

const setPaymentHistoryUnavailable = (
  state,
  {paymentHistoryUnavailableContracts}
) => {
  return {
    ...state,
    paymentHistoryUnavailableContracts: paymentHistoryUnavailableContracts,
  };
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_ID:
      return setUserId(state, action);
    case GET_PAYMENT_HISTORY:
      return setPaymentHistoryData(state, action);
    case GET_SCHEDULED_PAYMENT:
      return setScheduledPaymentData(state, action);
    case GET_TRANSACTIONS_HISTORY:
      return setTransactionsHistoryData(state, action);
    case GET_CONTRACTS:
      return setContractData(state, action);
    case GET_NOTIFICATIONS:
      return setInAppNotificationData(state, action);
    case GET_ACTIVE_TAB:
      return setActiveTab(state, action);
    case GET_CUSTOMER_INFORMATION:
      return setCustomerInformation(state, action);
    case GET_INPROGRESS_PAYMENTS:
      return setInprogressPayments(state, action);
    case GET_OTP:
      return setOtp(state, action);
    case GET_USER_DETAIL:
      return setUserDetails(state, action);
    case REMOVE_USER_DETAILS:
      return removeUserDetails(state);
    case GET_ASSET_INFORMATION:
      return setAssetInformationData(state, action);
    case GET_MACHINE_HEALTH_DETAILS:
      return setMachineHealthDetails(state, action);
    case GET_SKIP_TOUR:
      return setSkipTour(state, action);
    case GET_CUSTOMER_DETAILS:
      return setCustomerDetails(state, action);
    case GET_USER_NAME:
      return setUserName(state, action);
    case UPDATE_CUSTOMER_DETAILS:
      return updateCustomerDetails(state);
    case RESET_PRESERVED_STATE:
      return resetPreserveState(state);
    case GET_USER_LOCALE:
      return setUserLocale(state, action);
    case UPDATE_TNC_ACCEPTED:
      return updateTnCAcceptedDetails(state);
    case UPDATE_DD_TNC_ACCEPTED:
      return updateDDTnCAcceptedDetails(state);
    case SET_OFFERS_LOADING:
      return setOffersLoading(state, action);
    case SET_OFFERS_FOR_MFA_CUSTOMER:
      return setOffersData(state, action);
    case SET_OFFERS_FOR_MFA_NON_CUSTOMER:
      return setOffersNonMfaData(state, action);
    case SET_PERSONAL_OFFERS_LETTER_LOADING:
      return setPersonalOffersLetterLoading(state, action);
    case SET_PERSONAL_OFFERS_LETTER_DATA:
      return setPersonalOffersLetterData(state, action);
    case SET_SHOW_HIDE_PERSONAL_OFFER_LETTER:
      return setShowHidePersonalLetter(state, action);
    case UPDATE_USER_SCRATCH_THE_CARD:
      return updateUserScratchTheCard(state, action);
    case SET_NON_MFA_USER_MOBILE_NUMBER:
      return setNonMFAUserPhoneNumber(state, action);
    case SET_NON_MFA_USER_DATA:
      return updateNonMFAUserData(state, action);
    case SET_NON_MFA_ALERT:
      return setNonMfaAlert(state, action);
    case SET_CUSTOM_ALERT:
      return showHideAlert(state, action);
    case RESET_NON_MFA_ALERT:
      return resetNonMfaAlert(state, action);
    case NON_MFA_USER_VERIFICATION_SUCCESS:
      return nonMfaUserVerificationSuccess(state, action);
    case SET_OFFER_FOUND_BY_ID:
      return updateOfferFoundById(state, action);
    case SET_NON_MFA_OFFERS_LOADING:
      return setNonMFAUsersOffersLoading(state, action);
    case SET_SELECTED_OFFER_NON_MFA_CUSTOMER:
      return setSelectedOfferNonMfaData(state, action);
    case SET_OFFERS_VIEW:
      return setOfferView(state, action);
    case SET_OFFERS_SUBMIT:
      return setOfferSubmit(state, action);
    case NON_MFA_SET_VIEW:
      return setViewNonMFA(state, action);
    case SET_PREVIOUS_SUBMITTED_OFFERS_NON_MFA:
      return setPreviouslySubmittedOffers(state, action);
    case SET_TOTAL_ON_ACCOUNT_WITH_CONTRACT_NUMBER:
      return setOnAccountPaymentWithContractNumber(state, action);
    case ASK_USER_TO_ENABLE_PUSH:
      return askUserToEnablePush(state, action);
    case UPDATE_WHATSAPP_OPT_IN_DETAILS:
      return updateCustomerDetailsWhatsappOptIn(state, action);
    case SET_CONFIRM_PAYMENT_DATA:
      return {...state, confirmPaymentData: action.confirmPaymentData};
    case SET_TOTAL_ON_ACCOUNT_PAYMENT:
      return setOnAccountPayment(state, action);
    case PAYMENT_HISTORY_UNAVAILABLE:
      return setPaymentHistoryUnavailable(state, action);
    default:
      return state;
  }
};

export default reducer;
